import { useSelector } from 'react-redux';
import { ADMIN_HEADER_HEIGHT_ID } from 'components/admin/common/AdminHeaderContainer';
import { selectComponentHeight } from 'store/entities/ui/selectors';

export const useAdminHeaderHeight = () => useSelector(selectComponentHeight(ADMIN_HEADER_HEIGHT_ID));
